module.exports = {"38x36": __webpack_public_path__ + "images/satellite-3-36x38.png"};